import { useLocalStorageValue as V, useSessionStorageValue as d } from "@react-hookz/web";
import { useCallback as o, useMemo as f } from "react";
const R = (t, a) => {
  const {
    fetch: s,
    remove: l,
    set: c,
    value: e
  } = V(t, a), {
    fetch: r,
    remove: u,
    set: n,
    value: S
  } = d(t, a), h = o((g) => {
    try {
      c(g);
    } catch {
      n(g);
    }
  }, [c, n]), m = o(() => {
    s(), r();
  }, [s, r]), v = o(() => {
    l(), u();
  }, [l, u]), i = f(() => e ?? S, [e, S]);
  return {
    fetch: m,
    remove: v,
    set: h,
    value: i
  };
};
export {
  R as u
};
//# sourceMappingURL=fallback-storage-value-DraZAU_d.mjs.map
